

const setup = ({host}) => {
    window.ProveAnything.config = {
        functionUrl: host,
        functionPath: "/api/v1/public",
        functionAuthPath: "/api/v1/auth",
    }
}

export default {setup}